import { useState } from 'react';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';

const ContactPage = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Success modal'ı göster
    setShowSuccess(true);

    // Formu sıfırla
    setFormData({
      name: '',
      email: '',
      message: ''
    });

    // 3 saniye sonra modal'ı kapat
    setTimeout(() => {
      setShowSuccess(false);
    }, 3000);

    return false;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="wp-singular page-template page-template-elementor_header_footer page page-id-3245 wp-custom-logo wp-embed-responsive wp-theme-hello-elementor theme-default elementor-default elementor-template-full-width elementor-kit-3179 elementor-page elementor-page-3245">
      <style>{`
        .success-modal {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #fff;
          padding: 30px 40px;
          border-radius: 10px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
          z-index: 10000;
          text-align: center;
          min-width: 300px;
          animation: slideDown 0.3s ease-out;
        }

        .success-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 9999;
          animation: fadeIn 0.3s ease-out;
        }

        .success-icon {
          width: 60px;
          height: 60px;
          background: #5cb85c;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          animation: scaleUp 0.5s ease-out;
        }

        .success-icon svg {
          width: 35px;
          height: 35px;
          fill: white;
        }

        .success-modal h3 {
          color: #333;
          margin: 0 0 10px 0;
          font-size: 24px;
          font-weight: 600;
        }

        .success-modal p {
          color: #666;
          margin: 0;
          font-size: 16px;
          line-height: 1.5;
        }

        @keyframes slideDown {
          from { transform: translate(-50%, -60%); opacity: 0; }
          to { transform: translate(-50%, -50%); opacity: 1; }
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes scaleUp {
          0% { transform: scale(0); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
      `}</style>

      <Navigation />

      {/* Success Modal */}
      {showSuccess && (
        <>
          <div
            className="success-modal-overlay"
            onClick={() => setShowSuccess(false)}
          />
          <div className="success-modal" role="dialog" aria-modal="true">
            <div className="success-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
              </svg>
            </div>
            <h3>Mensagem Enviada!</h3>
            <p>
              A sua mensagem foi enviada com sucesso.
              <br />
              Entraremos em contacto em breve.
            </p>
          </div>
        </>
      )}

      <div
        data-elementor-type="wp-page"
        data-elementor-id="3245"
        className="elementor elementor-3245"
        data-elementor-post-type="page"
      >
        <div
          className="elementor-element elementor-element-4e9cf64 e-flex e-con-boxed e-con e-parent"
          data-id="4e9cf64"
          data-element_type="container"
        >
          <div className="e-con-inner">
            <div
              className="elementor-element elementor-element-af39f62 e-con-full e-flex e-con e-child"
              data-id="af39f62"
              data-element_type="container"
            >
              {/* Sol Taraf - İçerik */}
              <div
                className="elementor-element elementor-element-cbe9802 e-con-full e-flex e-con e-child"
                data-id="cbe9802"
                data-element_type="container"
              >
                <div
                  className="elementor-element elementor-element-aa4bb6b elementor-widget elementor-widget-heading"
                  data-id="aa4bb6b"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h1 className="elementor-heading-title elementor-size-default">
                      Fale Connosco
                    </h1>
                  </div>
                </div>

                <div
                  className="elementor-element elementor-element-ebc8f2a elementor-widget elementor-widget-text-editor"
                  data-id="ebc8f2a"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      Tem dúvidas, sugestões ou encontrou alguma informação desatualizada no nosso site?
                      <br />
                      Estamos aqui para ajudar!
                    </p>
                    <p>
                      No Casinonlineportugal, valorizamos o seu feedback. Se quiser partilhar a sua opinião,
                      reportar um erro ou saber mais sobre como funcionam as nossas comparações, não
                      hesite em entrar em contacto connosco.
                    </p>
                  </div>
                </div>

                <div
                  className="elementor-element elementor-element-3e8fadd elementor-widget elementor-widget-heading"
                  data-id="3e8fadd"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h4 className="elementor-heading-title elementor-size-default">
                      📧 Email de Suporte
                    </h4>
                  </div>
                </div>

                <div
                  className="elementor-element elementor-element-9ecc8e6 elementor-widget elementor-widget-text-editor"
                  data-id="9ecc8e6"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>Email geral: [contacto@Casinonlineportugal.site]</p>
                    <p>
                      Formulário de contacto: Preencha o formulário abaixo e responderemos o mais breve
                      possível.
                    </p>
                    <p>
                      Redes sociais: Siga-nos e envie mensagens diretamente através dos nossos canais
                      oficiais.
                    </p>
                  </div>
                </div>
              </div>

              {/* Sağ Taraf - Form */}
              <div
                className="elementor-element elementor-element-2953412 e-con-full e-flex e-con e-child"
                data-id="2953412"
                data-element_type="container"
              >
                <div
                  className="elementor-element elementor-element-4d725bd elementor-widget elementor-widget-heading"
                  data-id="4d725bd"
                  data-element_type="widget"
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <h3 className="elementor-heading-title elementor-size-default">
                      Enviar Mensagem
                    </h3>
                  </div>
                </div>

                <div
                  className="elementor-element elementor-element-0f71d16 elementor-button-align-stretch elementor-widget elementor-widget-form"
                  data-id="0f71d16"
                  data-element_type="widget"
                  data-settings='{"step_next_label":"Next","step_previous_label":"Previous","button_width":"100","step_type":"number_text","step_icon_shape":"circle"}'
                  data-widget_type="form.default"
                >
                  <div className="elementor-widget-container">
                    <form
                      className="elementor-form"
                      name="New Form"
                      action="#"
                      onSubmit={handleSubmit}
                    >
                      <div className="elementor-form-fields-wrapper elementor-labels-">
                        <div className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-100">
                          <label
                            htmlFor="form-field-name"
                            className="elementor-field-label elementor-screen-only"
                          >
                            Name
                          </label>
                          <input
                            size="1"
                            type="text"
                            name="name"
                            id="form-field-name"
                            className="elementor-field elementor-size-md elementor-field-textual"
                            placeholder="Nome"
                            value={formData.name}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="elementor-field-type-email elementor-field-group elementor-column elementor-field-group-email elementor-col-100 elementor-field-required">
                          <label
                            htmlFor="form-field-email"
                            className="elementor-field-label elementor-screen-only"
                          >
                            Email
                          </label>
                          <input
                            size="1"
                            type="email"
                            name="email"
                            id="form-field-email"
                            className="elementor-field elementor-size-md elementor-field-textual"
                            placeholder="Email"
                            required
                            value={formData.email}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="elementor-field-type-textarea elementor-field-group elementor-column elementor-field-group-message elementor-col-100">
                          <label
                            htmlFor="form-field-message"
                            className="elementor-field-label elementor-screen-only"
                          >
                            Message
                          </label>
                          <textarea
                            className="elementor-field-textual elementor-field elementor-size-md"
                            name="message"
                            id="form-field-message"
                            rows="4"
                            placeholder="Mensagem"
                            value={formData.message}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons">
                          <button className="elementor-button elementor-size-md" type="submit">
                            <span className="elementor-button-content-wrapper">
                              <span className="elementor-button-text">Enviar Mensagem</span>
                            </span>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <div
                  className="elementor-element elementor-element-f77bb50 elementor-widget elementor-widget-text-editor"
                  data-id="f77bb50"
                  data-element_type="widget"
                  data-widget_type="text-editor.default"
                >
                  <div className="elementor-widget-container">
                    <p>
                      Se está a enfrentar dificuldades relacionadas com o jogo, recomendamos que procure
                      apoio junto de instituições especializadas, como: Jogoresponsavel.pt Linha Vida –
                      1414
                    </p>
                    <p>Estamos comprometidos com um ambiente de jogo mais seguro e saudável.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactPage;